import React from 'react';
import { Box } from '@mui/material';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import { ProductGroupSelectEnhancedContainer as ProductGroupSelect } from './ProductGroupSelectEnhanced/ProductGroupSelectEnhancedContainer';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { ButtonGroup } from '../../ButtonGroup';
import { State } from '../redux';

const AccumulationThresholdFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type ComponentState = State['emConfiguration']['totalEligiblePurchaseOverTime'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  editMode: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const TotalEligiblePurchaseOverTimeConfiguration: React.FC<Props> = (props) => {
  const { accumulationThreshold, countProductsBy, editMode, eligibleProductGroups, fieldDisabled } =
    props;

  return (
    <Box>
      <Box mb={4}>
        <ButtonGroup
          label='Count Product By'
          name='countProductsBy'
          readonly={fieldDisabled('countProductsBy')}
          selectedValue={countProductsBy}
        >
          <ButtonGroup.Option value='quantity'>Quantity</ButtonGroup.Option>
          <ButtonGroup.Option value='money_amount'>Money Amount</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <AccumulationThresholdFormInput
          id='accumulationThreshold'
          label='Accumulation Threshold'
          readonly={fieldDisabled('accumulationThreshold')}
          type='text'
          value={accumulationThreshold}
          required={true}
        />
      </Box>

      <Box mb={4}>
        <ProductGroupSelect
          editMode={editMode}
          label='Included Product Groups'
          onChange={() => {}}
          readonly={fieldDisabled('eligibleProductGroups')}
          selectedProductGroups={eligibleProductGroups}
        />
      </Box>
    </Box>
  );
};

export { TotalEligiblePurchaseOverTimeConfiguration };
